/** Common time spans in milliseconds. */
export const MS_IN_DAY = 24 * 60 * 60 * 1000;
